const state = {
	loggedInUser: null,
	selectedDocuments: [],
	forceSendStore: process.env.VUE_APP_FORCE_SEND === 'true',
	cognitoUserData: {},
	note: '',
	selectedInvoices: [],
	env: '',
	dev: process.env.VUE_APP_ENVIRONMENT === 'development',
	beta: process.env.VUE_APP_BETA === 'true',
	legalEntities: [],
	selectedParticipantStore: null,
	selectedLegalEntityStore: null,
	participantUsers: [], // Store for assignees
	isDirty: false,
	phoneForm: undefined,
	selectedContact: null,
	selectedChannelEndpoint: null,
	isSuperAdmin: false,
	newNoteType: 'recipient',
	pdfPreviewDialogVisible: false,
	fullscreenLoading: false,
	selectedRecipient: undefined,
	selectedTemplate: undefined,
	PDFPreviewData: undefined,
	actionDetailDialogVisibleStore: false,
	emailDetailDialogMessage: undefined,
	emailDetailDialogVisibleStore: false,
	actionPhoneDetailDialogVisibleStore: false,
	componentTypeStore: undefined,
	actionTableVisibleStore: false,
	workListGroupedState: {},
	workListSortState: {},
	showActionTableFilters: false,
	actionTableSelectedChannels: undefined,
	actionTableSelectedStatuses: undefined,
	actionPhoneDetailOverlayVisible: false,
	actionPhoneDetailOverlayAction: undefined,
	licences: {},
	permissions: {},
	userInterfaceDetails: {},
	integrations: {},
	ssoDomains: {}
};

const mutations = {
	SET_SELECTED_DOCUMENTS: (state, data) => {
		state.selectedDocuments = data;
	},
	SET_FULL_SCREEN_LOADING: (state, data) => {
		state.fullscreenLoading = data;
	},
	SET_NEW_NOTE_TYPE: (state, data) => {
		state.newNoteType = data;
	},
	SET_LOGGED_IN_USER: (state, data) => {
		state.loggedInUser = data;
	},
	SET_FORCE_SEND: (state, data) => {
		state.forceSendStore = data;
	},
	SET_NOTE_FORM_VALUE: (state, data) => {
		state.note = data;
	},
	SET_SELECTED_INVOICES: (state, data) => {
		state.selectedInvoices = data;
	},
	SET_SELECTED_RECIPIENT: (state, data) => {
		state.selectedRecipient = data;
	},
	SET_ENVIRONMENT: (state, data) => {
		state.env = data;
	},
	SET_BETA: (state, data) => {
		state.beta = data;
	},
	SET_LEGAL_ENTITIES: (state, data) => {
		state.legalEntities = data;
	},
	SET_SELECTED_PARTICIPANT: (state, data) => {
		state.selectedParticipantStore = data;
	},
	SET_SELECTED_LEGAL_ENTITY: (state, data) => {
		state.selectedLegalEntityStore = data;
	},
	SET_COGNITO_USER_DATA: (state, data) => {
		state.cognitoUserData = data;
	},
	SET_IS_DIRTY: (state, data) => {
		state.isDirty = data;
	},
	SET_PHONE_FORM: (state, data) => {
		state.phoneForm = data;
	},
	SET_SELECTED_CONTACT: (state, data) => {
		state.selectedContact = data;
	},
	SET_SELECTED_CHANNEL_ENDPOINT: (state, data) => {
		state.selectedChannelEndpoint = data;
	},
	SET_PDF_PREVIEW_DIALOG_VISIBLE: (state, data) => {
		state.pdfPreviewDialogVisible = data;
	},
	SET_SELECTED_TEMPLATE: (state, data) => {
		state.selectedTemplate = data;
	},
	SET_PDF_PREVIEW_DATA: (state, data) => {
		state.PDFPreviewData = data;
	},
	SET_ACTION_DETAIL_DIALOG_VISIBLE: (state, data) => {
		state.actionDetailDialogVisibleStore = data;
	},
	SET_EMAIL_DETAIL_DIALOG_VISIBLE: (state, data) => {
		state.emailDetailDialogVisibleStore = data;
	},
	SET_EMAIL_DETAIL_DIALOG_MESSAGE: (state, data) => {
		state.emailDetailDialogMessage = data;
	},
	SET_ACTION_PHONE_DETAIL_DIALOG_VISIBLE: (state, data) => {
		state.actionPhoneDetailDialogVisibleStore = data;
	},
	SET_COMPONENT_TYPE_STORE: (state, data) => {
		state.componentTypeStore = data;
	},
	SET_ACTION_TABLE_VISIBLE: (state, data) => {
		state.actionTableVisibleStore = data;
	},
	SET_WORKLIST_GROUPED_STATE: (state, data) => {
		state.workListGroupedState = data;
	},
	SET_SHOW_ACTION_TABLE_FILTERS: (state, data) => {
		state.showActionTableFilters = data;
	},
	SET_WORKLIST_SORT_STATE: (state, data) => {
		state.workListSortState = data;
	},
	SET_ACTIONTABLE_SELECTED_CHANNELS: (state, data) => {
		state.actionTableSelectedChannels = data;
	},
	SET_ACTIONTABLE_SELECTED_STATUSES: (state, data) => {
		state.actionTableSelectedStatuses = data;
	},
	SET_ACTION_PHONE_DETAIL_OVERLAY_VISIBLE: (state, data) => {
		state.actionPhoneDetailOverlayVisible = data;
	},
	SET_ACTION_PHONE_DETAIL_OVERLAY_ACTION: (state, data) => {
		state.actionPhoneDetailOverlayAction = data;
	},
	SET_LICENCES: (state, data) => {
		state.licences = data;
	},
	SET_PERMISSIONS: (state, data) => {
		state.permissions = data;
	},
	SET_USER_INTERFACE_DETAILS: (state, data) => {
		state.userInterfaceDetails = data;
	},
	SET_INTEGRATIONS: (state, data) => {
		state.integrations = data;
	},
	SET_PARTICIPANT_USERS: (state, data) => {
		state.participantUsers = data;
	},
	SET_SSO_DOMAINS: (state, data) => {
		state.ssoDomains = data;
	}
};

const actions = {
	setSelectedDocuments({ commit }, data) {
		commit('SET_SELECTED_DOCUMENTS', data);
	},
	setLoggedInUser({ commit }, data) {
		commit('SET_LOGGED_IN_USER', data);
	},
	setSelectedInvoices({ commit }, data) {
		commit('SET_SELECTED_INVOICES', data);
	},
	setActionPhoneDetailOverlayVisible({ commit }, data) {
		commit('SET_ACTION_PHONE_DETAIL_OVERLAY_VISIBLE', data);
	},
	setActionPhoneDetailOverlayAction({commit }, data) {
		commit('SET_ACTION_PHONE_DETAIL_OVERLAY_ACTION', data);
	},
	setLicences({commit }, data) {
		commit('SET_LICENCES', data);
	},
	setPermissions({commit }, data) {
		commit('SET_PERMISSIONS', data);
	},
	setUserInterfaceDetails({commit }, data) {
		commit('SET_USER_INTERFACE_DETAILS', data);
	},
	setSsoDomains({commit }, data) {
		commit('SET_SSO_DOMAINS', data);
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	actions
};
